import { withSuspense } from '@lib/common/hoc';
import { lazy } from 'react';

const CreateContentMappingPage = withSuspense(lazy(() => import('./create-content-mapping')));
export default CreateContentMappingPage;
